var _path, _path2, _circle, _circle2, _rect, _rect2, _rect3, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCelebrate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 186,
    viewBox: "0 0 281 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.528 54.4502L217.835 106.171L196.137 113.879L187.528 54.4502Z",
    fill: "#EAD300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3964 108.925L79.5181 104.516L78.0839 122.559L31.3964 108.925Z",
    fill: "#EA0000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 129,
    r: 5,
    fill: "#9F00EA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.5,
    cy: 78.5,
    r: 11.5,
    fill: "#EAA900"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.4795,
    height: 16.7324,
    transform: "matrix(0.692168 -0.721736 0.706805 0.707408 88 174.164)",
    fill: "#EAA900"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9.70124,
    height: 16.4416,
    transform: "matrix(0.924162 0.382001 -0.367026 0.930211 248.035 57)",
    fill: "#EA0000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 40.2369,
    height: 13.3801,
    transform: "matrix(-0.448931 -0.893566 0.8921 -0.451837 133.064 42)",
    fill: "#EA0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00037 85.1617C1.00037 85.1617 22.3225 74.5584 27.1595 80.1159C29.8168 83.1692 31.8236 86.8672 29.4436 89.8717C27.6091 92.1878 24.9604 92.4831 21.857 91.9389C15.285 90.7865 15.3847 81.6744 18.0228 76.031C21.6652 68.2393 41.0004 72.8383 41.0004 72.8383",
    stroke: "#05EA00",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2698 150C75.2698 150 73.6703 140.361 78.2606 138.44C82.1169 136.825 85.4601 143.963 88.6288 141.376C91.8384 138.754 83.8262 134.602 86.4355 131.466C89.1817 128.167 98 131.466 98 131.466",
    stroke: "#005EEA",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6919 28C63.6919 36.2843 76.9701 43 67.7303 43C58.4904 43 51 36.2843 51 28C51 19.7157 58.4904 13 67.7303 13C76.9701 13 63.6919 19.7157 63.6919 28Z",
    fill: "#9F00EA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M259.193 126.171C264.703 126.726 270.06 118.343 269.441 124.489C268.822 130.635 263.854 135.168 258.343 134.614C252.832 134.059 248.867 128.627 249.485 122.481C250.104 116.334 253.682 125.616 259.193 126.171Z",
    fill: "#005EEA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M208.5 140L212.204 151.747L224.192 151.747L214.494 159.007L218.198 170.753L208.5 163.493L198.802 170.753L202.506 159.007L192.808 151.747L204.796 151.747L208.5 140Z",
    fill: "#05EA00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88 84L90.2451 90.9098H97.5106L91.6327 95.1803L93.8779 102.09L88 97.8197L82.1221 102.09L84.3673 95.1803L78.4894 90.9098H85.7549L88 84Z",
    fill: "#EAD300"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M180.63 40.7009L182.306 26.3925L193.987 33.7241L195.319 21.7209L205.974 28.9876L209.292 16.0112",
    stroke: "#005EEA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrate);
export default __webpack_public_path__ + "static/media/Celebrate.0760affac42b69e90425c22258443643.svg";
export { ForwardRef as ReactComponent };